const SESSION_KEY = "tyretrack_auth_session";
const LEGACY_USER_KEYS = ["tyretrack_user", "tiretrack_user"];

const readValue = (data, camelCase, snakeCase) => data[camelCase] ?? data[snakeCase];

export const normalizeAuthResponse = (data) => {
  const expiresIn = Number(readValue(data, "expiresIn", "expires_in"));
  const accessToken = readValue(data, "accessToken", "access_token");
  const refreshToken = readValue(data, "refreshToken", "refresh_token");
  const userId = Number(readValue(data, "userId", "user_id"));

  if (
    !accessToken ||
    !refreshToken ||
    !Number.isInteger(userId) ||
    userId <= 0 ||
    !Number.isFinite(expiresIn) ||
    expiresIn <= 0
  ) {
    throw new Error("Risposta di autenticazione non valida");
  }

  return {
    accessToken,
    refreshToken,
    expiresAt: Date.now() + expiresIn * 1000,
    user: {
      id: userId,
      email: data.email ?? "",
      displayName: readValue(data, "displayName", "display_name") ?? data.email ?? "",
      userName: readValue(data, "userName", "user_name") ?? "",
      roles: data.roles ?? [],
      estimator: data.estimator ?? 0,
      estimatorPro: readValue(data, "estimatorPro", "estimator_pro") ?? null,
      referentId: readValue(data, "referentId", "referent_id") ?? null,
      referentName: readValue(data, "referentName", "referent_name") ?? null,
      referalCode: readValue(data, "referalCode", "referal_code") ?? null,
    },
  };
};

export const getSession = () => {
  const value = localStorage.getItem(SESSION_KEY);
  if (!value) {
    return null;
  }

  try {
    const session = JSON.parse(value);
    if (
      !session?.accessToken ||
      !session?.refreshToken ||
      !session?.user ||
      !Number.isInteger(session.user.id)
    ) {
      throw new Error("Sessione non valida");
    }
    return session;
  } catch {
    localStorage.removeItem(SESSION_KEY);
    return null;
  }
};

export const saveSession = (session) => {
  localStorage.setItem(SESSION_KEY, JSON.stringify(session));
  LEGACY_USER_KEYS.forEach((key) => localStorage.removeItem(key));
};

export const clearSession = () => {
  localStorage.removeItem(SESSION_KEY);
  LEGACY_USER_KEYS.forEach((key) => localStorage.removeItem(key));
};
